const subdomainsUsingReverseProxy = ['quidco']
export const shouldUseReverseProxy = () => {
  const { hostname } = window.location
  return subdomainsUsingReverseProxy.findIndex((s) => hostname.includes(s)) > -1
}
